import { useLayoutEffect, useRef } from 'react';

import { FCC } from '@eluve/components';

import { extractMarketingParams } from './extract-marketing-params';

export const UrlParamNormalizer: FCC = ({ children }) => {
  const hasNormalized = useRef(false);

  useLayoutEffect(() => {
    if (hasNormalized.current) return;

    const currentUrl = new URL(window.location.href);
    const params = currentUrl.searchParams;
    const redirectTo = params.get('redirectTo') ?? params.get('redirectToPath');

    if (redirectTo) {
      const marketingParams = extractMarketingParams(redirectTo);
      if (Object.keys(marketingParams).length > 0) {
        const existingParams = Array.from(params.keys());
        for (const [key, value] of Object.entries(marketingParams)) {
          if (!existingParams.includes(key)) {
            params.set(key, value);
          }
        }
        const newUrl = `${currentUrl.pathname}?${params.toString()}`;
        window.history.replaceState(null, '', newUrl);
      }
    }

    hasNormalized.current = true;
  }, []);

  return children;
};
